@import '../../../constants/spacing.module.less';

.bulk-recommendation-banner-loading-indicator-container {
  margin: @space-36 @space-0 @space-32 @space-0;
}
